"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPropertyDefinitions = getPropertyDefinitions;
const property_1 = require("@genesys/property");
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const field_groups_1 = require("./field-groups");
const values_1 = require("./property-definitions/values");
const CoilDefinition = __importStar(require("./property-definitions/common/coil-definition"));
const TubeDefinition = __importStar(require("./property-definitions/common/tube-definition"));
const FinDefinition = __importStar(require("./property-definitions/common/fins-definition"));
const InletcollectorDefinition = __importStar(require("./property-definitions/common/inletcollector-definition"));
const OutletcollectorDefinition = __importStar(require("./property-definitions/common/outletcollector-definition"));
const SafetyDefinition = __importStar(require("./property-definitions/common/safety-definition"));
const AirInputsDefinition = __importStar(require("./property-definitions/common/airinputs-definition"));
const ExpressAirInputsDefinition = __importStar(require("./property-definitions/common/express-airinputs-definition"));
const CoefficientsDefinition = __importStar(require("./property-definitions/common/coefficients-definition"));
const CalculationMethodDefinition = __importStar(require("./property-definitions/common/calculationmethod-definition"));
const FluidInputDefinition = __importStar(require("./property-definitions/fluid/input-definition"));
const InletHeaderDefinition = __importStar(require("./property-definitions/fluid/inletheader-definition"));
const OutletHeaderDefinition = __importStar(require("./property-definitions/fluid/outletheader-definition"));
const FluidConstraintsDefinition = __importStar(require("./property-definitions/fluid/constraints-definition"));
const TemperaturesOutDefinition = __importStar(require("./property-definitions/fluid/temperatures-out-definition"));
const FlowsDefinition = __importStar(require("./property-definitions/fluid/flows-definition"));
const DxInputDefinition = __importStar(require("./property-definitions/dx/input-definition"));
const SteamInputDefinition = __importStar(require("./property-definitions/steam/input-definition"));
const StepPropertyDefinition = __importStar(require("./property-definitions/steam/stepproperty-definition"));
const SteamPressureDefinition = __importStar(require("./property-definitions/steam/pressures-definition"));
const SteamAirSweepsDefinition = __importStar(require("./property-definitions/steam/air-sweeps-definition"));
const InputTemperaturesDefinition = __importStar(require("./property-definitions/steam/input-temperatures-definition"));
const InputHumiditiesDefinition = __importStar(require("./property-definitions/steam/input-humidities-definition"));
// A group's key is written out in full, `coilprotool_group_<name>`, because the properties
// selector has no `groupName` hook in `customTranslation` to prefix it the way property labels
// and their values are prefixed.
const Group = {
    coil: "coilprotool_group_coil",
    tube: "coilprotool_group_tube",
    fins: "coilprotool_group_fins",
    inletCollector: "coilprotool_group_inletcollector",
    outletCollector: "coilprotool_group_outletcollector",
    safety: "coilprotool_group_safety",
    airInputs: "coilprotool_group_airinputs",
    coefficients: "coilprotool_group_coefficients",
    calculationMethod: "coilprotool_group_calculationmethod",
    fluidInput: "coilprotool_group_fluidinput",
    inletHeader: "coilprotool_group_inletheader",
    outletHeader: "coilprotool_group_outletheader",
    fluidConstraints: "coilprotool_group_fluidconstraints",
    fluidTemperaturesOut: "coilprotool_group_fluidtemperaturesout",
    fluidFlows: "coilprotool_group_fluidflows",
    dxInput: "coilprotool_group_dxinput",
    steamInput: "coilprotool_group_steaminput",
    steamStepProperty: "coilprotool_group_steamstepproperty",
    steamAirSweeps: "coilprotool_group_steamairsweeps",
    steamPressures: "coilprotool_group_steampressures",
    steamAirTemperatures: "coilprotool_group_steamairtemperatures",
    steamAirHumidities: "coilprotool_group_steamairhumidities"
};
const setGroup = (group) => (property) => (Object.assign(Object.assign({}, property), { group }));
/**
 * The properties one coil type takes, assembled from the parts that apply to it.
 *
 * The coil type is not a property any more, so nothing here is filtered on it: a module is
 * either loaded for this coil type or it is not. What survives as a visibility filter is the
 * genuine within-type conditional - a fluid side given by flow rather than by outlet
 * temperature, an express run stepping one quantity rather than another.
 */
function getPropertyDefinitions(propertyValues, mode, coilType) {
    const express = mode === "express-calculate";
    const side = (0, field_groups_1.sideSegment)(coilType);
    const airInputs = express
        ? ExpressAirInputsDefinition.propertyDefinition(propertyValues, 
        // Only a steam express run sweeps the inlet air, and while it does the single value is
        // hidden. Every other coil type shows both unconditionally.
        coilType === "steam"
            ? (0, values_1.filter)(SteamAirSweepsDefinition.notSteppingTemperature)
            : property_1.PropertyFilter.Empty, coilType === "steam"
            ? (0, values_1.filter)(SteamAirSweepsDefinition.notSteppingHumidity)
            : property_1.PropertyFilter.Empty)
        : AirInputsDefinition.propertyDefinition(propertyValues);
    const panels = [
        {
            segment: "common",
            groups: [Group.coil, Group.tube, Group.fins],
            readonly: ["coilheight", "coilwidth"],
            properties: [
                ...CoilDefinition.propertyDefinition().map(setGroup(Group.coil)),
                ...TubeDefinition.propertyDefinition().map(setGroup(Group.tube)),
                ...FinDefinition.propertyDefinition().map(setGroup(Group.fins))
            ]
        },
        ...(coilType === "fluid"
            ? [
                {
                    // Headers are the one piece of the coil itself that only a fluid coil has.
                    segment: "fluid",
                    groups: [Group.inletHeader, Group.outletHeader],
                    readonly: [],
                    properties: [
                        ...InletHeaderDefinition.propertyDefinition().map(setGroup(Group.inletHeader)),
                        ...OutletHeaderDefinition.propertyDefinition().map(setGroup(Group.outletHeader))
                    ]
                }
            ]
            : []),
        {
            segment: "common",
            groups: [Group.inletCollector, Group.outletCollector, Group.safety],
            readonly: [],
            properties: [
                ...InletcollectorDefinition.propertyDefinition().map(setGroup(Group.inletCollector)),
                ...OutletcollectorDefinition.propertyDefinition().map(setGroup(Group.outletCollector)),
                ...SafetyDefinition.propertyDefinition().map(setGroup(Group.safety))
            ]
        },
        {
            segment: "common",
            groups: [Group.airInputs, Group.coefficients, Group.calculationMethod],
            readonly: [],
            properties: [
                ...airInputs.map(setGroup(Group.airInputs)),
                ...CoefficientsDefinition.propertyDefinition().map(setGroup(Group.coefficients)),
                ...CalculationMethodDefinition.propertyDefinition().map(setGroup(Group.calculationMethod))
            ]
        },
        ...coilSide(propertyValues, express, coilType, side)
    ];
    return panels.map((panel, i) => (Object.assign(Object.assign({}, panel), { key: `section-${i + 1}` })));
}
/**
 * The side of the coil the air exchanges heat with: what it takes, and - for an express run -
 * the values it walks.
 */
function coilSide(propertyValues, express, coilType, segment) {
    switch (coilType) {
        case "fluid": {
            // Both modes can modulate a fluid coil to a target temperature, so both need the
            // constraints that search is bounded by.
            const constraints = FluidConstraintsDefinition.propertyDefinition().map(setGroup(Group.fluidConstraints));
            const input = express
                ? FluidInputDefinition.expressPropertyDefinition()
                : FluidInputDefinition.propertyDefinition();
            const side = {
                segment,
                groups: [Group.fluidInput, Group.fluidConstraints],
                readonly: [],
                properties: [...input.map(setGroup(Group.fluidInput)), ...constraints]
            };
            if (!express) {
                return [side];
            }
            return [
                side,
                {
                    segment,
                    groups: [Group.fluidTemperaturesOut, Group.fluidFlows],
                    readonly: [],
                    properties: [
                        ...TemperaturesOutDefinition.propertyDefinition(propertyValues).map(setGroup(Group.fluidTemperaturesOut)),
                        ...FlowsDefinition.propertyDefinition(propertyValues).map(setGroup(Group.fluidFlows))
                    ]
                }
            ];
        }
        case "dx":
        case "condenser":
            // CoilPro takes the same refrigerant side for both, and express offers neither.
            return [
                {
                    segment,
                    groups: [Group.dxInput],
                    readonly: [],
                    properties: DxInputDefinition.propertyDefinition().map(setGroup(Group.dxInput))
                }
            ];
        case "steam": {
            if (!express) {
                return [
                    {
                        segment,
                        groups: [Group.steamInput],
                        readonly: [],
                        properties: SteamInputDefinition.propertyDefinition().map(setGroup(Group.steamInput))
                    }
                ];
            }
            return [
                {
                    segment,
                    groups: [
                        Group.steamStepProperty,
                        Group.steamInput,
                        Group.steamAirSweeps
                    ],
                    readonly: [],
                    properties: [
                        ...StepPropertyDefinition.propertyDefinition().map(setGroup(Group.steamStepProperty)),
                        ...SteamInputDefinition.expressPropertyDefinition().map(setGroup(Group.steamInput)),
                        // The inlet-air sweeps belong to the steam side, not to the air inputs: no other
                        // coil type steps the air state.
                        ...SteamAirSweepsDefinition.propertyDefinition(propertyValues).map(setGroup(Group.steamAirSweeps))
                    ]
                },
                {
                    segment,
                    groups: [
                        Group.steamPressures,
                        Group.steamAirTemperatures,
                        Group.steamAirHumidities
                    ],
                    readonly: [],
                    properties: [
                        ...SteamPressureDefinition.propertyDefinition(propertyValues).map(setGroup(Group.steamPressures)),
                        ...InputTemperaturesDefinition.propertyDefinition(propertyValues).map(setGroup(Group.steamAirTemperatures)),
                        ...InputHumiditiesDefinition.propertyDefinition(propertyValues).map(setGroup(Group.steamAirHumidities))
                    ]
                }
            ];
        }
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(coilType);
            throw new Error(`No definitions for coil type ${coilType}`);
    }
}
//# sourceMappingURL=property-definitions.js.map